/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefUserData } from '../../models/api-def-user-data';

export interface AuthSessionLogin$Params {
      body: {

/**
 * CSRF token for the request
 */
'csrfToken': string;

/**
 * Firebase ID token to exchange
 */
'idToken': string;
}
}

export function authSessionLogin(http: HttpClient, rootUrl: string, params: AuthSessionLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'userData'?: ApiDefUserData;
}>> {
  const rb = new RequestBuilder(rootUrl, authSessionLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'userData'?: ApiDefUserData;
      }>;
    })
  );
}

authSessionLogin.PATH = '/auth/sessionLogin';
